import { createSelector } from '@ngrx/store';

import { loyaltyIntroductionPagesImagesState } from '../root';

export const getLoyaltyIntroductionPagesImages = createSelector(loyaltyIntroductionPagesImagesState, (loyaltyIntroductionPagesImages) => loyaltyIntroductionPagesImages);
